import React from 'react';
import { Globe, Award, Clock, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

export const About = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const icons = [Globe, TrendingUp, Award, Clock];

  const features = [
    { title: t.globalSourcing, description: t.globalSourcingDesc },
    { title: t.seasonalVariety, description: t.seasonalVarietyDesc },
    { title: t.qualityAssured, description: t.qualityAssuredDesc },
    { title: t.reliableDistribution, description: t.reliableDistributionDesc },
  ];

  return (
    <section id="about" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-6">
            {t.aboutTitle}
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.aboutDescription}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {features.map((feature, index) => {
            const Icon = icons[index];
            
            return (
              <Card
                key={index}
                className="border-none shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-orange-50"
              >
                <CardContent className="p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <div className="p-3 bg-orange-100 rounded-full shadow-sm">
                      <Icon className="w-8 h-8 text-orange-600" strokeWidth={1.5} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
